import http from "../modules/http.index"
import { Form } from "vform"
const state = () => ({
    loading: false,
    AdditionalServices: [],
    AdditionalServicesForm: new Form({
        id: '',
        desc: "",
        title: "",
        cost: "",
    }),
    headers: [
        {
            text: "Id",
            align: "start",
            filterable: false,
            value: "id",
        },
        { text: "Title", value: "title" },
        { text: "Desc", value: "desc" },
        { text: "Amount", value: "cost" },
        { text: "Action", value: 'actions', sortable: false, },

    ],
})

const getters = {}
const mutations = {
    setAdditionalServices: (state, payload) => state.AdditionalServices = payload
}
const actions = {
    async getAdditionalServices(ctx) {
        return new Promise((resolve, reject) => {
            ctx.state.loading = true
            http
                .get(`/Setups/AdditionalServices/${ctx.rootState.site_id}`)
                .then((res) => {
                    if (res.status === 200) {
                        ctx.commit("setAdditionalServices", res.data.Data)
                        resolve(res)
                    } else reject(res)
                })
                .catch((err) => reject(err))
                .finally(() => ctx.state.loading = false)
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
